import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  container: { width: '100%', padding: theme.spacing(3) },
  mainContainer: {
    backgroundColor: 'white',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: theme.spacing(3),
  },
  title: {
    fontSize: "1.8rem",
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  documentsContainer: {
    margin: '32px 0',
    padding: '0 32px',
  },
  rowContainer: { borderLeft: '4px solid #cfd8dc' },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  headerCell: {
    backgroundColor: "#fafafa",
    color: "#607d8b",
    textAlign: "left",
    fontSize: "16px",
    fontWeight: "bold"
  }
}));

export default useStyles;
